<template>
  <div class="d-flex">
    <div class="d-flex align-items-center" v-if="file.type === 'event'">
      <div class="pr-3">
        <i class="far fa-calendar"></i>
      </div>
      <div>
        <div>
          {{ file.name }}
        </div>
        <div style="font-size: 0.8em; font-weight: 300">
          {{ file.date | formatDate}}
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center" v-if="file.type === 'external'">
      <div class="pr-3">
        <i class="fas fa-link"></i>
      </div>
      <div>
        <a class="external-link" :href="file.link" target="_blank">{{ file.name }}</a>
      </div>
    </div>
    <div class="d-flex align-items-center document-link" v-if="file.type === 's3'" @click="startDownload">
      <div class="pr-3">
        <i class="fas fa-download"></i>
      </div>
      <div >
        {{ file.name }}
      </div>
    </div>
    <b-modal v-model="showDownloadDialogue" hide-header hide-footer>
      <div class="d-flex flex-column align-items-center justify-content-center p-4" style="background: #FFFFFF; color: #000000">
        <div style="font-size: 1.5em;">
          {{ file.name }}
        </div>
        <div class="loading-dialogue text-center" v-if="isLoading">
          <div style="font-size: 1.5em;">
            YOUR DOWNLOAD IS BEING PREPARED.
          </div>
          <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
        </div>
        <div class="p-5" v-if="!isLoading && url !== null">
          <a class="btn btn-lg btn-dark" target="_blank" :href="url" download>
            DOWNLOAD
          </a>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import API from '../../api'

export default {
  name: '',
  props: ['file'],
  data: function () {
    return {
      showDownloadDialogue: false,
      url: null,
      isLoading: false
    }
  },
  methods: {
    startDownload () {
      this.showDownloadDialogue = true
      this.isLoading = true
      this.setS3File()
    },
    setS3File () {
      API.getS3FileURL(this.file.link).then(
        response => {
          this.url = response.data.url
          this.isLoading = false
        }
      )
    },
  }
}
</script>

<style scoped>
.document-link {
  cursor: pointer;
}
.document-link:hover {
  text-decoration: underline;
}
.external-link{
  color: #000000;
}
.external-link a {
  color: #000000;
}
.external-link a:hover {
  color: #000000
}
</style>



// WEBPACK FOOTER //
// src/components/boardOfDirectors/DownloadableDocument.vue